module.exports = __webpack_public_path__ + "img/cantic.e34a4747.svg";